const minZoomSm = 1
const minZoomLg = 2
let minZoom = MobDet ? minZoomSm : minZoomLg

const layers = {
	granada: L.tileLayer('assets/images/maptiles/granada/{z}/{x}/{y}.jpg', {
			attribution: '',
			maxZoom: 4,
			minZoom,
			continuousWorld: false,
			noWrap: true,
			crs: L.CRS.simple,
			detectRetina: true
	}),
	castilla: L.tileLayer('assets/images/maptiles/castilla/{z}/{x}/{y}.jpg', {
			attribution: '',
			maxZoom: 4,
			minZoom,
			continuousWorld: false,
			noWrap: true,
			crs: L.CRS.simple,
			detectRetina: true
	}),
	moro: L.tileLayer('assets/images/maptiles/moro/{z}/{x}/{y}.jpg', {
			attribution: '',
			maxZoom: 4,
			minZoom,
			continuousWorld: false,
			noWrap: true,
			crs: L.CRS.simple,
			detectRetina: true
	}),
	marina: L.tileLayer('assets/images/maptiles/marina/{z}/{x}/{y}.jpg', {
			attribution: '',
			maxZoom: 4,
			minZoom,
			continuousWorld: false,
			noWrap: true,
			crs: L.CRS.simple,
			detectRetina: true
	}),
	club: L.tileLayer('assets/images/maptiles/club/{z}/{x}/{y}.jpg', {
			attribution: '',
			maxZoom: 4,
			minZoom,
			continuousWorld: false,
			noWrap: true,
			crs: L.CRS.simple,
			detectRetina: true
	})
};

export {layers};